module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/97926439955086f8ee4aabbd81580f17.png";